//global_reducer.js

// ============================================================
// ENV SWITCH — change ONLY this line
//   "local" = local backends (127.0.0.1)
//   "prod"  = production servers
// ============================================================
const ENV = "prod"; // "local" | "prod"

const ENV_CONFIG = {
  // Local: your machine / LAN backends
  local: {
    targetIp: "http://127.0.0.1:8080",
    userManagementUrl: "http://127.0.0.1:8080",
    gatewayUrl: "http://127.0.0.1:5003",
    keyCloakAuth: "http://139.59.8.119:8070/auth/",
    KeycloakApi: "http://192.168.100.72:8084/api/keycloak",
    // Other local POS IPs you used before (uncomment targetIp in this block if needed):
    // targetIp: "http://192.168.100.123:8080",
    // targetIp: "http://192.168.100.119:8080",
    // targetIp: "http://192.168.100.21:8080",
    // targetIp: "http://192.168.100.65:8080",
    // targetIp: "http://192.168.100.72:8080",
  },
  // Production: live Hulm servers
  prod: {
    targetIp: "https://api-pos.hulmsolutions.com",
    userManagementUrl: "https://api-pos.hulmsolutions.com",
    gatewayUrl: "https://api.hulmsolutions.com",
    keyCloakAuth: "https://keycloak.hulmsolutions.com/auth/",
    KeycloakApi: "https://api-pos.hulmsolutions.com/api/keycloak",
  },
};

const env = ENV_CONFIG[ENV] || ENV_CONFIG.local;
const targetIp = env.targetIp;

const initial_state = {
  targetIp: `${targetIp}/POS`,
  // FOR KUBE
  //  targetIp: `${targetIp}`,
  ip: `${targetIp}/POS`,

  // POS gateway for tenant APIs (AuthZ goes through POS → UMS)
  userManagementUrl: env.userManagementUrl,
  umsInstanceId: "",
  userManagement: `${env.userManagementUrl}/POS/`,
  companyName: "",
  instanceId: "",
  basePath: "",
  appType: "",
  appName: "",

  gatewayUrl: env.gatewayUrl,

  zatcaUrl: "https://api-pos.hulmsolutions.com/api/fatoora",
  zatcaSetupUrl: "https://api-pos.hulmsolutions.com/api/setup",

  temp: `http://${targetIp}:9086/ViewsService/Views/bucket2/sputnik.hpos.e2a2e917-168e-4d1e-8ff5-81b2628b68e4/image.png`,
  imageUrl: `http://${targetIp}:9086/ViewsService/Views/bucket2/`,
  keyCloakAuth: env.keyCloakAuth,
  KeycloakApi: env.KeycloakApi,
  isAuthenticated: false,
  keycloakinstance: null,
  mediaBaseUrl: `https://s3.hulmsolutions.com/upload`,
  bussinessType: "",
  currencyCode: "PKR",
  currencyLabel: "Rs",
};

const globalReducer = (state = initial_state, action) => {
  switch (action.type) {
    case "GET_BASE_URL": {
  const companyName = action.payload?.companyName || state.companyName;
  const instanceId = action.payload?.instanceId || state.instanceId;
  const appType = action.payload?.appType || state.appType;
  const umsInstanceId =
    action.payload?.umsInstanceId !== undefined
      ? action.payload.umsInstanceId
      : state.umsInstanceId;

  // Normalize slashes and construct path
  const cleanIp = state.ip.endsWith('/') ? state.ip.slice(0, -1) : state.ip;

  // Construct basePath ONLY if we have minimum required info
  let basePath = state.basePath;
  if (companyName && instanceId) {
    basePath = `${cleanIp}/${companyName}/${instanceId}`;
  }

  console.log("🔧 GET_BASE_URL - Setting:", { companyName, instanceId, appType, basePath, umsInstanceId });

  return {
    ...state,
    basePath: basePath,
    companyName: companyName,
    instanceId: instanceId,
    appType: appType,  // Make sure this is set correctly
    umsInstanceId: umsInstanceId || state.umsInstanceId || "",
  };
}

    case "GET_GLOBAL_URL":
      return state;

    case "SETTING_AUTHENTICATION":
      return {
        ...state,
        isAuthenticated: action.payload?.isAuthenticated,
        keycloakinstance: action.payload?.keycloakinstance,
      };

    case "BUSSINESS_TYPE":
      return {
        ...state,
        bussinessType: action.payload?.bussinessType,
      };

    case "SET_CURRENCY_CODE":
      return {
        ...state,
        currencyCode: action.payload?.currencyCode || state.currencyCode || "PKR",
        currencyLabel: action.payload?.currencyLabel || state.currencyLabel || "Rs",
      };

    case "GLOBAL_RESET":
      return {
        ...state,
        instanceId: "",
        appType: "",
        companyName: "",
        bussinessType: "",
        currencyCode: "PKR",
        currencyLabel: "Rs",
        basePath: "",
        isAuthenticated: false,
        keycloakinstance: null,
      };

    default:
      return state;
  }
};


export default globalReducer;
